export default __webpack_public_path__ + "static/media/HamburgesaOrd.e7358f34.svg";